import { PostAsync, GetAllAsync, PatchAsync } from './api';
import { ZoneResponse, ZoneListItem } from '../types/responses/zone-response.d';

const ZoneEndpoint = `zones`;
const AdminZonesEndpoint = 'admin/zones';

/**
 * Adds a new Zone to the system.
 * @param payload - the Zone object to add
 * returns the created Zone object.
 * @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Methods/POST
 */
export const AddZoneLibraryAsync = async (payload: ZoneResponse) =>
  PostAsync<any>(`${ZoneEndpoint}`, payload);

/**
 * Gets ALL Pending Zones encapsulated in a paged payload.
 * @returns all Zone objects.
 * @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Methods/GET
 */
export const GetPendingZonesAsync = async (params?: string) =>
  GetAllAsync<ZoneListItem>(`${AdminZonesEndpoint}?${params}`);

/**
 * Approves a Zone by id.
 * @param zoneId - the ID of the Zone to approve
 * @returns the updated Zone object.
 * @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Methods/PATCH
 */
export const ApproveZoneAsync = async (zoneId: number) =>
  PatchAsync<ZoneListItem>(`${AdminZonesEndpoint}/${zoneId}/approve`, {});

/**
 * Rejects a Zone by id.
 * @param zoneId - the ID of the Zone to reject
 * @returns the updated Zone object.
 * @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Methods/PATCH
 */
export const RejectZoneAsync = async (zoneId: number) =>
  PatchAsync<ZoneListItem>(`${AdminZonesEndpoint}/${zoneId}/reject`, {});

/**
 * Submits a Zone to the global library.
 * @param zoneId - the ID of the Zone to submit
 * @returns the updated Zone object.
 * @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Methods/PATCH
 */
export const SubmitZoneAsync = async (zoneId: number) =>
  PatchAsync<any>(`${ZoneEndpoint}/${zoneId}/submit`, {});

